<template>
    <div
        class="room-component flex h-full w-full items-center justify-center"
        :class="{ 'cursor-pointer': isClickable }"
        :style="{ width: widthPx, height: heightPx, background: statusBackground }"
        @click="select"
    >
        <div class="room-title text-center text-sm dark:text-black" :style="{ fontSize }">
            {{ number }}
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'RoomComponent',
    props: {
        size: Number,
        number: String,
        width: Number,
        layout: String,
        corridor: Boolean,
        clickable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapState('Room', {
            count: function (state) {
                return state.rooms[this.number]?.count;
            },
            sex: function (state) {
                return state.rooms[this.number]?.sex;
            }
        }),
        ...mapState('User', { user: (state) => state.user }),
        widthPx() {
            return this.layout === 'vertical'
                ? `${5.5 * (this.corridor ? this.size * 0.75 : this.size)}px`
                : `${this.width * this.size}px`;
        },
        heightPx() {
            return this.layout === 'vertical'
                ? `${this.width * this.size}px`
                : `${5 * (this.corridor ? this.size / 2 : this.size)}px`;
        },
        fontSize() {
            return this.size > 12 ? `${this.size}px` : 0;
        },
        statusBackground() {
            if (this.user && this.user.room_number === this.number) {
                return 'var(--room-reserved)';
            }
            switch (this.count) {
                case 0:
                    return 'var(--room-empty)';
                case 1:
                    if(this.sex == 'MALE')
                        return 'linear-gradient(135deg,var(--room-half) 0%,var(--room-half) 85%,var(--gender-male) 85%, var(--gender-male) 100%) no-repeat, var(--room-half)'
                    if(this.sex == 'FEMALE')
                        return 'linear-gradient(135deg,var(--room-half) 0%,var(--room-half) 85%,var(--gender-female) 85%, var(--gender-female) 100%) no-repeat, var(--room-half)'
                    return 'var(--room-half)';
                case 2:
                    return 'var(--room-full)';
            }
            if (!this.clickable) {
                return 'var(--room-readonly)';
            }
            return 'var(--room-disabled)';
        },
        isClickable() {
            return (
                this.layout === 'vertical' &&
                (!this.user || typeof this.count !== 'undefined') &&
                this.clickable
            );
        },
    },
    methods: {
        ...mapActions('Popup', ['selectRoom', 'reserveRoom', 'cancelRoom', 'applyToRoom']),
        select(event) {
            if (this.isClickable) {
                this.selectRoom(this.number);
                event.stopPropagation();
            }
        },
    },
};
</script>

<style scoped>
.room-title {
    z-index: 10;
}
.room-component {
    border: 1px solid rgba(0, 0, 0, 0.25);
    overflow: hidden;
    transition: transform 150ms ease-in-out, border-radius 150ms ease-in-out;
}
.room-component:hover.cursor-pointer {
    transform: scale(1.2);
    border-radius: 4px;
    z-index: 100;
}

</style>
